<template>
  <div>
    <div class="rowLabel">{{ $t('editor.inspector.values') }}
      <HelpOverlay :content="$t('editor.inspector.hints.values')"/>
    </div>
    <div v-if="config != null" class="valueList">
      <div class="valueRow" v-for="(val, idx) in values" :key="idx">{{val}}
        <div class="actions">
          <span v-if="!isTemplate" class="action" @click="editValue(idx)"><i class="fas fa-pen"></i></span>
          <span v-if="!isTemplate" class="action" @click="removeValue(idx)"><i class="fas fa-trash"></i></span>
          <span v-if="!isTemplate" class="action" :class="{inactive: idx == 0}" @click="moveValueUp(idx)"><i class="fas fa-angle-up"/></span>
          <span v-if="!isTemplate" class="action" :class="{inactive: idx == values.length-1}" @click="moveValueDown(idx)">
            <i class="fas fa-angle-down"></i>
          </span>
        </div>
      </div>
    </div>
    <input v-if="!isTemplate" type="text" class="hasPicker" v-model='newValue' :placeholder="$t('editor.inspector.placeholder.newValue')" @keyup.enter="addValue()"/>
    <div v-if="!isTemplate" class="addButton" @click="addValue()"><i class="fas fa-plus-square"></i></div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import EditableField from '@/helpers/EditableField';
// import Constants from '@/helpers/Constants';
import HelpOverlay from '@/components/HelpOverlay.vue';

export default {
  name: 'DropDownInspectorComponent',
  props: {
    currentField: {
      type: EditableField,
      default: null,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HelpOverlay,
  },
  data() {
    return {
      config: null,
      values: [],
      newValue: '',
    };
  },
  watch: {
    currentField(newVal) {
      this.update(newVal);
    },
  },
  mounted() {
    this.update(this.currentField);
  },
  methods: {
    update(newVal) {
      try {
        this.config = newVal != null ? newVal.config : null;
        if (this.config != null) {
          const decoded = Buffer.from(this.config.special, 'base64');
          this.values = JSON.parse(decoded).values;
        }
      } catch (e) {
        console.error(e);
      }
    },
    addValue() {
      if (this.values == null || this.values.constructor !== Array) this.values = [];
      if (this.newValue.trim().length > 0) {
        this.values.push(this.newValue);
      }
      this.newValue = '';
      this.store();
    },
    async editValue(idx) {
      // eslint-disable-next-line no-alert
      this.$emit('showValueInputPrompt', this.values[idx], (updated) => {
        if (updated != null && updated.trim().length > 0) {
          this.values[idx] = updated;
        }
        this.store();
      });
    },
    moveValueUp(idx) {
      if (idx > 0) {
        const tmp = this.values[idx - 1];
        this.values[idx - 1] = this.values[idx];
        this.values[idx] = tmp;
        this.store();
      }
    },
    moveValueDown(idx) {
      if (idx < this.values.length - 1) {
        const tmp = this.values[idx + 1];
        this.values[idx + 1] = this.values[idx];
        this.values[idx] = tmp;
        this.store();
      }
    },
    removeValue(idx) {
      this.values.splice(idx, 1);
      this.store();
    },
    store() {
      this.config.special = Buffer.from(JSON.stringify({ values: this.values })).toString('base64');
    },
  },
  computed: {
  },
};
</script>

<style scoped>
.actions {
  float: right;
}
.action {
  background: var(--color_brown);
  color: white;
  padding: 4px;
  font-size: 0.8em;
  margin-left: 4px;
  cursor: pointer;
  border: none;
}

.action:hover {
  background: var(--color_orange);
}

.action.inactive {
  background: var(--color_light_brown);
  cursor: default;
}
.valueList {
  max-height: 150px;
  overflow-y: auto;
}
.valueRow {
  margin: 8px 0px;
  border-bottom: 0.5px solid #444;
  min-height: 24px;
}
</style>
